import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Oct 30 2018
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { jsonConversions, WindowTypeConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api/index';
import logger from '../../logger/index';
import { CRUTransportLayer } from '../CRUTransportLayer';
export var WindowTypeLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(WindowTypeLayer, _CRUTransportLayer);

  function WindowTypeLayer() {
    var _this;

    _classCallCheck(this, WindowTypeLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowTypeLayer).call(this, CONSTANTS.API.ENDPOINTS.SETTINGS_WINDOW_TYPE));
    /**
     * Gets all items from repository
     * @returns all items from repository
     */

    _this.findAll = function () {
      var findAllPromise = api(CONSTANTS.API.ENDPOINTS.SETTINGS_WINDOW_TYPE).get({
        responseType: 'json'
      }).then(function (response) {
        var windowTypes = [];
        (response.data.result || []).map(function (type) {
          windowTypes.push(_this.getConverter().toObject(type, jsonConversions));
        });
        return windowTypes;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return findAllPromise;
    };
    /**
     * Gets one particular item based on theme id
     * @returns one particular item from repository
     */


    _this.findOne = function (id) {
      var findPromise = api(CONSTANTS.API.ENDPOINTS.SETTINGS_WINDOW_TYPE_SINGLE(id)).get({
        responseType: 'json'
      }).then(function (response) {
        var type = response.data.value || {};
        return _this.getConverter().toObject(type, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return findPromise;
    };
    /**
     * Blocks/Un-blocks WindowType
     * @param windowType - WindowType schema
     */


    _this.block = function (windowType) {
      var blockPromise = api(CONSTANTS.API.ENDPOINTS.SETTINGS_WINDOW_TYPE_BLOCK).post(windowType, {
        responseType: 'json'
      }).then(function (response) {
        var type = response.data.result || {};
        return _this.getConverter().toObject(type, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return blockPromise;
    };
    /**
     * Deletes one particular item based on WindowType id
     * @param id
     */


    _this.delete = function (id) {
      var deletePromise = api(CONSTANTS.API.ENDPOINTS.SETTINGS_WINDOW_TYPE_SINGLE(id)).delete().then(function () {
        return Promise.resolve();
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return deletePromise;
    };

    return _this;
  }

  _createClass(WindowTypeLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }]);

  return WindowTypeLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", WindowTypeConverter)], WindowTypeLayer.prototype, "converter", void 0);